<template>
  <div class="base-report report-shop-sales-analyze">
    <div class="filter">
      <el-form inline>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData"  :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          :summary-method="getSummaries"
          height="100%">
          <template v-for="(header, index) in tableSetting">
            <template v-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportShopPaymentAnalyze',
  data () {
    return {
      ratioStr: null,
      isLoading: false,
      modes: [{value: 1, label: '日毎'}, {value: 2, label: '月毎'}],
      tableSetting: [
        {label: '店舗', prop: 'shopName', align: 'left', fixed: true, sortable: true, width: '130px'},
        {label: '売上(税抜)'},
        [
          {label: '当年', prop: 'salesExcludeTaxNow', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'salesExcludeTaxLastyear', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'salesExcludeTaxPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'salesBudgetNow', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'salesBudgetPer', align: 'right', sortable: true, width: '100px'},
        ],
        {label: '客数'},
        [
          {label: '当年', prop: 'personNow', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'personLastyear', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'personPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'budgetPerson', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'personBudgetPersonPer', align: 'right', sortable: true, width: '100px'},
        ],
        {label: '客単価'},
        [
          {label: '当年', prop: 'salesPerson', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'salesPersonLastyear', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'salesPersonPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'salesPersonBudget', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'salesPersonBudgetPer', align: 'right', sortable: true, width: '100px'},
        ],
      ],
      searchForm: {
        from_date: null,
        to_date: null,
      },
      screenData: [],
      orgData: [],
      orgTotalData: {},
      totalData: [],
      csv_filename: '店舗別売上分析.csv',
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
    ...mapGetters('report', ['ratioStrFunction']),
  },
  watch: {
    isGroupMode (val) {
      if (!val) {
        this.$router.push({name: 'Home'})
      }
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.orgData = []
      this.screenData = []
      this.orgTotalData = {}

      this.$request.reports.reportShopSalesAnalyze(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method).then(res => {
        let data = res.body
        if (data.records) {
          for (let record of data.records) {
            switch (record.type) {
              case 'record':
                this.screenData.push(record.data)
                break
              case 'total':
                this.orgTotalData = record.data
                break
            }
          }
        }
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key], record['party']))
        }
        data.push(tmp)
      }

      let totalData = this.totalData
      if (this.searchForm.accumulate) {
        totalData = null
      }
      downloadCSV(this.csv_filename, header, data, totalData)
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key], row['party'])
    },
    formatData (key, value) {
      switch (key) {
        case 'shopName':
          return value
        case 'salesExcludeTaxPer':
          return this.ratioStr(value)
        case 'salesBudgetPer':
          return this.ratioStr(value)
        case 'personPer':
          return this.ratioStr(value)
        case 'personBudgetPersonPer':
          return this.ratioStr(value)
        case 'salesPersonPer':
          return this.ratioStr(value)
        case 'salesPersonBudgetPer':
          return this.ratioStr(value)
        default:
          return addFigure(Math.round(value))
      }
    },
    getSummaries ({columns, data}) {
      columns.forEach((column, index) => {
        let prop = columns[index].property
        this.totalData[index] = this.formatData(prop, this.orgTotalData[prop])
      })
      return this.totalData
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportShopSalesAnalyze.vue